import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    longNameField: {
      '& .MuiTypography-root': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: 280,
        padding: '0 16px',
      },
    },
    menuOptions: {
      fontSize: 12,
      fontWeight: 500,
    },
    title: {
      fontSize: 12,
      color: palette.grey700,
      fontWeight: 500,
      margin: 4,
      width: '100%',
      justifyContent: 'space-between',
      display: 'flex',
      cursor: 'pointer',
    },
    titleConfig: { cursor: 'default' },
    graphLegendsContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    detailsButton: {
      borderColor: palette.navCompanyContextActions,
      color: palette.navCompanyContextActions,
      width: '100%',
      padding: 1,
      marginLeft: 11,
    },
    titleSelected: {
      fontSize: 12,
      color: palette.green,
      fontWeight: 500,
      margin: 4,
      width: '100%',
      justifyContent: 'space-between',
      display: 'flex',
      cursor: 'pointer',
    },
    titleDoughnut: {
      fontSize: 12,
      color: palette.grey700,
      fontWeight: 500,
      margin: 12,
      width: '65%',
      justifyContent: 'space-between',
      display: 'flex',
    },
    filterIcon: { fontSize: 16, color: palette.blue, marginLeft: 4 },
    filterIconGreen: { fontSize: 16, color: palette.green, marginLeft: 4 },
    busyIcon: { fontSize: 16 },
    titleRed: {
      fontSize: 12,
      color: palette.red,
      fontWeight: 500,
      margin: 19,
      width: '60%',
      justifyContent: 'space-between',
      display: 'flex',
      alignItems: 'center',
    },
    numberFields: {
      textAlign: 'center',
      fontSize: 12,
      color: palette.darkGray,
    },
    centerFields: {
      textAlign: 'center',
      fontSize: 12,

      '& .MuiIconButton-root': {
        padding: 0,
      },
    },
    accessButton: {
      fontSize: 15,
      color: palette.blue,
    },
    listGrid: {
      paddingLeft: 10,
    },
    tableLine: {
      fontSize: 12,
      cursor: 'pointer',
      color: palette.darkGray,
    },
    searchContainer: { alignItems: 'center', justifyContent: 'space-between' },
    dateField: {
      fontSize: 12,
      whiteSpace: 'nowrap',
      '& > div': {
        justifyContent: 'center',
      },
    },
    textAndIcon: {
      color: palette.darkGray,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      whiteSpace: 'nowrap',
      marginRight: 10,

      '& svg': {
        fontSize: 15,
        marginRight: 10,
      },
    },
    summaryRowTable: {
      backgroundColor: `${palette.white} !important`,
      height: '20px !important',

      '& .MuiTableCell-root': {
        padding: 0,
      },
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
        cursor: 'pointer',
      },
    },
    envRow: {
      backgroundColor: `${palette.lightYellow} !important`,
      height: '20px !important',
      cursor: 'pointer',

      '& .MuiTableCell-root': {
        padding: 0,
      },
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
      },
    },
    changeAccountContainer: { padding: 15 },
    currentAccount: {
      fontWeight: 'bold',
      fontSize: 14,
      color: palette.blue,
    },
    newAccount: {
      fontWeight: 'bold',
      fontSize: 14,
      color: palette.green,
    },
    accountName: { fontSize: 16 },
    arrow: {
      position: 'absolute',
      top: '47%',
      left: '47%',
      transform: 'translate(-50%, -50%) rotate(270deg)',
      cursor: 'pointer',

      '& span': {
        display: 'block',
        width: 10,
        height: 10,
        borderBottom: `2px solid ${palette.green}`,
        borderRight: `2px solid ${palette.green}`,
        transform: 'rotate(45deg)',
        margin: -10,
        animation: '$arrow 2s infinite',
      },

      '& span:nth-child(2)': {
        animationDelay: '-0.2s',
      },
      '& span:nth-child(3)': {
        animationDelay: '-0.4s',
      },
    },
    '@keyframes arrow': {
      '0%': {
        opacity: '0',
        transform: 'rotate(45deg) translate(-20px, -20px)',
      },
      '50%': {
        opacity: '1',
      },
      '100%': {
        opacity: '0',
        transform: 'rotate(45deg) translate(20px, 20px)',
      },
    },
    envsToExpire: {
      border: `1px solid ${palette.red}`,
      color: palette.red,
      fontSize: 12,
    },
    icon: { fontSize: 22 },
    avatar: {
      cursor: 'pointer',
      width: 24,
      height: 24,
    },
    avatarCompanyContext: {
      backgroundColor: palette.lightNavCompanyContextActions,
      color: palette.navCompanyContextActions,
    },
    avatarAdmin: {
      backgroundColor: palette.lightNavAdminActions,
      color: palette.navAdminActions,
    },
    avatarSuperAdmin: {
      backgroundColor: palette.lightNavSuperAdminActions,
      color: palette.navSuperAdminActions,
    },
    avatarOperator: {
      backgroundColor: palette.lightNavOperatorActions,
      color: palette.navOperator,
    },
    iconGrid: {
      margin: '8px 16px 8px 0',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    options: {
      margin: 8,
      display: 'flex',
      alignItems: 'center',
      border: `1px solid ${palette.gray}`,
      cursor: 'pointer',
      borderRadius: 30,
      padding: '4px 8px',
      '& .MuiCheckbox-root': { padding: '0px 2px 0px 0px !important' },
    },
    optionsSelected: {
      border: `1px solid ${palette.green}`,
      cursor: 'pointer',
      backgroundColor: palette.lightGreen,
      padding: '4px 6px',
    },
    activeAllText: {
      fontSize: 15,
      fontWeight: 500,
      marginRight: 6,
    },
    optionTextSelected: {
      fontSize: 15,
      fontWeight: 500,
      color: palette.green,
      marginRight: 6,
    },
    checkIcon: { fontSize: 20, color: palette.green },
    ghostCheckIcon: { fontSize: 0, color: palette.white },
    cardGrid: { marginTop: 6 },
    statusModalGrid: { marginBottom: 16 },
    gridAutoCard: {
      margin: 3,
      height: 230,
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    gridAutoCardLoad: {
      margin: 3,
      height: 230,
      alignItems: 'center',
      justifyContent: 'center',
    },
    gridAutoCardModal: {
      margin: 3,
      height: 230,
      alignItems: 'center',
      justifyContent: 'space-evenly',
    },
    displayFlex: { display: 'flex', alignItems: 'center', marginLeft: 8 },
    cardsTitle: {
      fontSize: 14,
      color: palette.darkGray,
      marginBottom: 4,
      fontWeight: 550,
    },
    cardsTitleModal: {
      fontSize: 14,
      color: palette.darkGray,
      fontWeight: 550,
    },
    productTypeTitle: { fontSize: 12, marginLeft: 2 },
    label: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      maxWidth: 100,
      margin: 0,
    },
    labelSmall: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      maxWidth: 60,
      margin: 0,
    },
    dashboardHeader: { marginTop: 16 },
    dashboardButtonsHeader: {
      color: palette.blue,
      padding: '4px 8px!important',
      '&:hover': {
        backgroundColor: palette.superLightDeepBlue,
      },
    },
    dashboardButtonsHeaderConfig: {
      color: palette.blue,
      padding: '4px 8px!important',
      marginLeft: 16,
      '&:hover': {
        backgroundColor: palette.superLightDeepBlue,
      },
    },
    cardSelector: {
      margin: 6,
      maxWidth: '32%',
      width: '32%',
      cursor: 'pointer',
      borderRadius: 'var(--borderRadius, 4px)',
      border: `1px solid ${palette.grey300}`,
      background: '#FCFCFC',
      boxShadow: '0px 1px 30px 0px rgba(0, 0, 0, 0.05)',
    },
    cardPreview: {
      margin: '6px 6px 16px 6px',
      borderRadius: 'var(--borderRadius, 4px)',
      border: `1px solid ${palette.grey300}`,
      background: '#FCFCFC',
      boxShadow: '0px 1px 30px 0px rgba(0, 0, 0, 0.05)',
      justifyContent: 'center',
      display: 'flex',
      width: 'max-content',
    },
    cardPreviewItem: {
      margin: 6,
      borderRadius: 'var(--borderRadius, 4px)',
      border: `1px solid ${palette.grey300}`,
      background: '#FCFCFC',
      boxShadow: '0px 1px 30px 0px rgba(0, 0, 0, 0.05)',
      padding: 8,
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
    },
    closeIcon: {
      color: palette.red,
      fontSize: 20,
      cursor: 'pointer',
      marginRight: 2,
    },
    dragIcon: {
      color: palette.blue,
      fontSize: 20,
      cursor: 'grab',
      marginLeft: 2,
    },
    cardSelectorActive: {
      border: `1px solid ${palette.green}`,
      margin: 6,
      borderRadius: 4,
      maxWidth: '32%',
      width: '32%',
      backgroundColor: palette.lightGreen,
    },
    modalCardHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 4,
    },
    checkIconModal: { fontSize: 20, color: palette.green },
    modalCardHeaderCollapse: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 0,
    },
    cleanIcon: { color: palette.red, fontSize: 26, cursor: 'pointer' },
    cleanButton: {
      color: palette.red,
      padding: '4px 8px!important',
      '&:hover': {
        backgroundColor: palette.superLightRed,
      },
    },
    switchText: { fontSize: 12, fontWeight: 500, marginLeft: 2 },
    switchGrid: { alignItems: 'center', display: 'flex', marginRight: '8px' },
    switchGridContainer: { marginBottom: 16 },
    cardPreviewNoDash: {
      margin: '6px 6px 16px 6px',
      borderRadius: 'var(--borderRadius, 4px)',
      border: `1px solid ${palette.grey300}`,
      background: '#FCFCFC',
      boxShadow: '0px 1px 30px 0px rgba(0, 0, 0, 0.05)',
      justifyContent: 'center',
      display: 'flex',
      padding: 8,
      alignItems: 'center',
    },
    noDashIcon: {
      color: palette.grey600,
      fontSize: 18,
      marginRight: 4,
    },
    optionsModal: { display: 'flex', justifyContent: 'flex-end' },
    previewModal: { display: 'flex', justifyContent: 'center' },

    infoIcon: {
      fontSize: 15,
      color: palette.gray,
    },
  });

export const overrideCard = {
  minHeight: 0,
  '&:after': {
    content: '""',
    position: 'absolute',
    width: 160,
    height: 168,
    borderRadius: '50%',
    zIndex: 1,
    top: -75,
    right: -125,
    opacity: 0.5,
  },
  '&:before': {
    content: '""',
    position: 'absolute',
    zIndex: 1,
    width: 150,
    height: 180,
    borderRadius: '50%',
    top: -130,
    right: -80,
    opacity: 0.5,
  },
};

export const overrideCardDoughnut = {
  minHeight: 0,
  '&:after': {
    visibility: 'hidden',
  },
  '&:before': {
    visibility: 'hidden',
  },
};

export const overrideFilter = {
  text: {
    fontWeight: 500,
    fontSize: 14,
  },
  listItem: { '& .MuiTypography-body1': { fontSize: 14 } },
};

export const overrideModalStatus = {
  content: {
    padding: 12,
    fontSize: '12px !important',
    height: 550,
    width: 800,
    overflowX: 'auto',
  },
};
